module.exports = __webpack_public_path__ + "static/media/high-five.1443ac91.png";